import RailwayPackageLimitType from './railway_package_limit_type';

export default RailwayPackageLimitType;
